import React from 'react';
import { NavLink } from 'react-router-dom';

import './NavigationItems.css';

const navItems = [
  { id: "feed", text: "سفارشات", link: "/", auth: true },
  { id: "feed", text: "محصولات", link: "/product", auth: true },
  { id: "feed", text: "رنگ", link: "/color", auth: true },
  { id: "feed", text: "سایز", link: "/size", auth: true },
  { id: "feed", text: "برند", link: "/brand", auth: true },
  { id: "feed", text: "گارانتی", link: "/warranty", auth: true },
  { id: "addProduct", text: "درج محصول", link: "/add-product", auth: true },
  { id: "category", text: "گروه کالایی", link: "/category", auth: true },
  { id: "Classification", text: "دسته بندی", link: "/Classification", auth: true },
  { id: "Attribute",    text: "ویژگی‌های کالایی",    link: "/Attribute",    auth: true },
  // { id: "signup", text: "ثبت نام", link: "/signup", auth: false },
  { id: "login", text: "ورود", link: "/", auth: false },
];

const navigationItems = props => [
  ...navItems.filter(item => item.auth === props.isAuth).map((item, index) => (
    <li
      key={index}
      className={['navigation-item', props.mobile ? 'mobile' : ''].join(' ')}
    >
      <NavLink to={item.link} exact onClick={props.onChoose}>
        {item.text}
      </NavLink>
    </li>
  )),
  props.isAuth && (
    <li className="navigation-item" key="logout">
      <button onClick={props.onLogout}>خروج</button>
    </li>
  )
];

export default navigationItems;
